import { connect } from "react-redux";
import AudioCard from "./components";
import { playAudio } from "../../../actions";

const mapDispatchToProps = (dispatch) => {
  return {
    playAudio: (track) => {
      dispatch(playAudio(track));
    },
  };
};

export default connect(null, mapDispatchToProps)(AudioCard);
